import { CheckoutPageFragment } from '@/hooks/CheckoutPage/checkoutPageFragments.gql';
import { gql } from '@apollo/client';

export const CREATE_ACCOUNT = gql`
  mutation CreateAccount($email: String!, $password: String!, $is_subscribed: Boolean!) {
    createCustomer(input: { email: $email, password: $password, is_subscribed: $is_subscribed }) {
      # The createCustomer mutation returns a non-nullable CustomerOutput type
      # which requires that at least one of the sub fields be returned.

      # eslint-disable-next-line @graphql-eslint/require-id-when-available
      customer {
        email
      }
    }
  }
`;

export const GET_CUSTOMER = gql`
  query GetCustomerAfterCreate {
    # eslint-disable-next-line @graphql-eslint/require-id-when-available
    customer {
      email
      firstname
      lastname
      is_subscribed
    }
  }
`;

export const SIGN_IN = gql`
  mutation SignInAfterCreate($email: String!, $password: String!) {
    generateCustomerToken(email: $email, password: $password) {
      token
    }
  }
`;

export const CREATE_CART = gql`
  mutation CreateCartAfterAccountCreation {
    cartId: createEmptyCart
  }
`;

export const GET_CART_DETAILS = gql`
  query GetCartDetailsAfterAccountCreation($cartId: String!) {
    cart(cart_id: $cartId) {
      id
      # eslint-disable-next-line @graphql-eslint/require-id-when-available
      items {
        uid
        prices {
          price {
            value
          }
        }
        # eslint-disable-next-line @graphql-eslint/require-id-when-available
        product {
          uid
          name
          sku
          small_image {
            url(type: "small")
            label
          }
          price {
            regularPrice {
              amount {
                value
              }
            }
          }
        }
        quantity
        # eslint-disable-next-line @graphql-eslint/require-id-when-available
        ... on ConfigurableCartItem {
          # eslint-disable-next-line @graphql-eslint/require-id-when-available
          configurable_options {
            configurable_product_option_uid
            option_label
            configurable_product_option_value_uid
            value_label
          }
        }
      }
      prices {
        grand_total {
          value
          currency
        }
      }
    }
  }
`;

export const MERGE_CARTS = gql`
  mutation MergeCartsAfterAccountCreation($sourceCartId: String!, $destinationCartId: String!) {
    mergeCarts(source_cart_id: $sourceCartId, destination_cart_id: $destinationCartId) {
      id
      # eslint-disable-next-line @graphql-eslint/require-id-when-available
      items {
        uid
      }
      ...CheckoutPageFragment
    }
  }
  ${CheckoutPageFragment}
`;

export const MERGE_GUEST_CARTS = gql`
  mutation MergeGuestCarts($sourceCartId: String!, $targetCartId: String!) {
    mergeGuestCarts(sourceCartId: $sourceCartId, targetCartId: $targetCartId) {
      id
    }
  }
`;

export const SWITCH_STORE_BY_QUOTE = gql`
  mutation SwitchStoreByQuote($cart_id: String!, $store_code: String!) {
    switchStoreByQuote(cart_id: $cart_id, store_code: $store_code) {
      email
      id
      is_virtual
      total_quantity
    }
  }
`;

export default {
  createAccountMutation: CREATE_ACCOUNT,
  createCartMutation: CREATE_CART,
  getCartDetailsQuery: GET_CART_DETAILS,
  getCustomerQuery: GET_CUSTOMER,
  mergeCartsMutation: MERGE_CARTS,
  mergeGuestCartsMutation: MERGE_GUEST_CARTS,
  switchStoreMutation: SWITCH_STORE_BY_QUOTE,
  signInMutation: SIGN_IN,
};
